import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {get as _get} from 'lodash';

import {convertToInt} from '@utils/helpers';
import mapModulesToProps from '@utils/mapModulesToProps';
import {PRODUCT_LCT} from '@constants/variables';
import {getLink} from '@appComponents/Link';

import ClientProductForm from './ClientProductForm';
import {deleteSuccessCallback, setClientProductsEntity} from '../utils/clientProducts';

class ClientProductLctForm extends ClientProductForm {
    componentDidMount() {
        super.componentDidMount();

        const entityName = 'client',
            params = {
                clientData: this.props.clientData,
                entityName,
                setEntity: this.props.Entity.setEntity,
            };

        this.setCreateSuccessCallback((response) => {
            this.props.Entity.setEntity({
                name: entityName,
                data: {...this.props.clientData,
                    clientProducts: this.props.clientData.clientProducts.concat(
                        response.data.createClientProductLct.client_product
                    ),
                },
            });

            this.props.history.push(getLink('clients.products.lct.editGeoRestrictions', {
                id: this.props.match.params.id,
            }));
        });

        this.setUpdateSuccessCallback((response) => {
            const clientProductLctIndex = this.props.clientData.clientProducts.findIndex(clientProduct =>
                    PRODUCT_LCT === convertToInt(clientProduct.product.id)
                ),
                clientProducts = {};

            clientProducts[clientProductLctIndex] = {
                ...response.data.updateClientProductLct.client_product,
            };
            params.clientProducts = clientProducts;

            setClientProductsEntity(params);
        });

        this.setDeleteSuccessCallback(() => {
            params.formParamsId = this.props.formParams.id;
            params.historyPush = this.props.history.push;

            deleteSuccessCallback(params);
        });
    }

    componentDidUpdate(prevProps) {
        const {
            formParams,
            GraphQLEntityData,
            GraphQLOptionsData,
        } = this.props;

        const isAddForm = _get(formParams, 'isAddForm');
        const clientProductsLct = _get(GraphQLEntityData, 'clientProductsLct', []);
        const entityLoading = _get(GraphQLEntityData, 'loading', false);
        const optionsProduct = _get(GraphQLOptionsData, 'product');
        const optionsLoading = _get(GraphQLOptionsData, 'loading', false);
        let augmentedPrevProps = prevProps;

        if (!optionsLoading && !entityLoading && !this.state.dataReceived) {
            if (!isAddForm && 0 < clientProductsLct.length) {
                augmentedPrevProps = { ...prevProps, clientProduct: clientProductsLct[0].client_product };

                this.setField('id', {defaultValue: convertToInt(clientProductsLct[0].id)});
            }

            this.handleInitialSlaFieldVisibility(isAddForm, clientProductsLct, optionsProduct);
            super.componentDidUpdate(augmentedPrevProps);
        }
    }

    prepareDataForSubmit(data) {
        data = {...data, product: PRODUCT_LCT};

        return super.prepareDataForSubmit(data);
    }
}

const mapDispatchToProps = mapModulesToProps(['Entity']),
    mapStateToProps = (state) => ({clientData: state.app.entities.client || null});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ClientProductLctForm));
